module.exports = "/_next/static/images/d61024317576c68a4f3654b6d3be9bc5-double-card@3x.png";